import { render, staticRenderFns } from "./projectsSave.vue?vue&type=template&id=62ddb3c3"
import script from "./projectsSave.vue?vue&type=script&lang=js"
export * from "./projectsSave.vue?vue&type=script&lang=js"
import style0 from "./projectsSave.vue?vue&type=style&index=0&id=62ddb3c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports